import React from 'react';
import type { FC } from 'react';
import { Key, Text, useInput } from '@wix/cli-ui-kit';
import { useWixCliAppBi } from '../../bi-app/index.js';

interface Props {
  onClose: () => void;
}

export const CloseScreen: FC<Props> = ({ onClose }) => {
  const bi = useWixCliAppBi();

  useInput((_, key) => {
    if (key.escape) {
      bi.cliAction({
        question: 'Press to close',
        questionKey: 'general.close_screen',
        action: 'close',
        key: 'esc',
      });
      onClose();
    }
  });

  return (
    <Text skin="secondary">
      Press <Key value="esc" skin="secondary" /> to close
    </Text>
  );
};
